import React from 'react';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

import { useIsMobile } from 'styles/hooks/mediaQueries';
import { MOBILE_CREATE_GROUP_ORDER_CTA_LABEL } from 'bento-ordering/group_ordering/constants/groupOrder';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import HowItWorks from 'bento-ordering/group_ordering/components/HowItWorks';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { GROUP_ORDER } from 'bento-ordering/group_ordering/constants/entities';
import {
  selectIsGroupOrderingEnabled,
  selectCartIsGroupOrder
} from 'bento-ordering/cart/selectors/index';
import {
  getButtonFontHoverColor,
  getButtonFontColor
} from 'styles/helpers/getThemeStyles';

const StyledGroupAddIcon = styled(GroupAddIcon)(({ theme }) => ({
  fill: getButtonFontColor(theme),
  '&:hover': {
    fill: getButtonFontHoverColor(theme)
  }
}));

const CreateGroupOrderMobileCTA = () => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const groupOrderingEnabled = useSelector(selectIsGroupOrderingEnabled);
  const isCartGroupOrder = useSelector(selectCartIsGroupOrder);

  const handleCTAOnClick = () => {
    const path = generatePath(GROUP_ORDER, 'groupOrderSettings');

    dispatch(push(path));
  };

  return (
    <>
      {!isCartGroupOrder && groupOrderingEnabled && isMobile && (
        <Box padding="23px 16px 0px">
          <PrimaryCta
            disabled={false}
            handleClick={handleCTAOnClick}
            type="button"
            fullWidth
            label={
              <Box display="flex">
                <StyledGroupAddIcon />
                <Box component="span" marginLeft={1}>
                  {MOBILE_CREATE_GROUP_ORDER_CTA_LABEL}
                </Box>
              </Box>
            }
          />
          <Box paddingTop={1}>
            <HowItWorks />
          </Box>
        </Box>
      )}
    </>
  );
};

export default CreateGroupOrderMobileCTA;
